import { Gauge, Layers, ShieldCheck } from "lucide-react";
import type { SlideProps } from "@/engine/types";
import { GlassCard, Reveal, RevealItem, RevealList, SlideShell } from "@/ui";

const CARDS = [
  {
    icon: ShieldCheck,
    title: "“Authority” ≈ trust",
    body: (
      <>
        How much search engines might <span className="font-semibold text-white">trust</span> a
        page or site vs others in a niche — inferred from{" "}
        <span className="font-semibold text-white">links</span>,{" "}
        <span className="font-semibold text-white">mentions</span>, and{" "}
        <span className="font-semibold text-white">history</span>.
      </>
    ),
  },
  {
    icon: Gauge,
    title: "Tool scores are models",
    body: (
      <>
        Third-party domain / page scores model that idea — they are{" "}
        <span className="font-semibold text-white">not a public “Google score”</span>{" "}
        and can disagree with each other.
      </>
    ),
  },
  {
    icon: Layers,
    title: "Many signals, one focus",
    body: (
      <>
        Google's own systems use many signals: focus on{" "}
        <span className="font-semibold text-white">helpful, reliable content</span> and{" "}
        <span className="font-semibold text-white">earned reputation</span> — not chasing a
        single metric.
      </>
    ),
  },
] as const;

export function AuthoritySlide({ active }: SlideProps) {
  return (
    <SlideShell chapter={1} title="Page authority and site strength">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-14">
        <RevealList active={active} stagger={0.18} delay={0.25} className="grid grid-cols-3 gap-8">
          {CARDS.map(({ icon: Icon, title, body }) => (
            <RevealItem key={title} className="h-full">
              <GlassCard className="group flex h-full flex-col gap-5 p-8 transition-transform duration-300 hover:-translate-y-1">
                <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-white/10 bg-white/5 transition-colors duration-300 group-hover:border-accent-cyan/40">
                  <Icon className="h-7 w-7 text-accent-cyan" strokeWidth={2} />
                </div>
                <h3 className="font-display text-3xl font-semibold text-white">{title}</h3>
                <p className="text-2xl leading-relaxed text-white/80">{body}</p>
              </GlassCard>
            </RevealItem>
          ))}
        </RevealList>

        <Reveal active={active} delay={1.1} y={16}>
          <p className="text-2xl text-white/70">
            People say <span className="font-semibold text-white/90">“authority”</span>{" "}
            a lot — it's a shorthand, not a number Google publishes.
          </p>
        </Reveal>
      </div>
    </SlideShell>
  );
}
